import React from 'react'
import filter_color from "../../assets/images/design/colorFilter.svg"
import document_security from "../../assets/images/contents/document-security.png"
import { PrimaryButton, PrimaryButton2th } from '../../components/StyledButtons'
import WhitepaperDownloadForm from './WhitepaperDownloadForm'
import OtherWhitepapers from './OtherWhitepapers'
import testing_inspection_whitepaper from "../../assets/images/contents/testing-inspection-whitepaper.png"
import banking_whitepaper from "../../assets/images/contents/banking-whitepaper.png"
import pdf_stamping from "../../assets/images/contents/stamping-pdf.png"
import Navbar from '../../components/Navbar'
import IndustriesImageContainer from '../../components/IndustriesImageContainer'
import Footer from '../../components/Footer'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { selectLanguage } from '../../redux/language/selector'

const DocumentSecurity = () => {
  const handleScroll = () => {
    const targetElement = document.getElementById('download-whitepaper-form');
    if (targetElement) {
        const yOffset = 0;
        const y = targetElement.getBoundingClientRect().top + window.pageYOffset + yOffset;
        window.scrollTo({ top: y, behavior: 'smooth' });
    }
};

  const { t } = useTranslation()

  const language = useSelector(selectLanguage)

  const items = [
    {
      id: 1,
      link: '/whitepapers/testing-inspection',
      image: testing_inspection_whitepaper,
      chip: t("whitepapers-tab.testing-inspection-whitepaper"),
      title: t('whitepapers.testing-inspection-title'),
      content: t('whitepapers.testing-inspection-content'),
    },
    {
      id: 2,
      link: '/whitepapers/pdf-stamping',
      image: pdf_stamping,
      chip: t("whitepapers-tab.pdf-stamping-whitepaper"),
      title: t('whitepapers.pdf-stamping-title'),
      content: t('whitepapers.pdf-stamping-content')
    },
    {
      id: 3,
      link: '/whitepapers/banking',
      image: banking_whitepaper,
      chip: t("whitepapers-tab.banking-whitepaper"),
      title: t('whitepapers.banking-title'),
      content: t('whitepapers.banking-content')
    },
  ];

  return (
    <div className='document-security bg-primary'>
      <div className='color-filter-right' style={{ top: "45%" }}>
        <img src={filter_color} alt="" className='img-responsive' />
      </div>
      <div className='color-filter-left' style={{ top: "55%" }} >
        <img src={filter_color} alt="" className='img-responsive' />
      </div>

      <Navbar />
      <div className='container-fluid hr-document-security-header'>
        <div className='container pt-100 pt-md-150'>
          <div className='col-sm-12 col-xl-7 px-md-0 pt-f768-t991-0'>
            {language === "en" ?
              <>
                <p className='font-64 font-weight-semi-bold header-sub-title pr-lg-50'>Get the Latest Insights on </p>
                <p className='font-64 font-weight-semi-bold header-sub-title'>Document Security |</p>
                <p className='font-60 font-weight-semi-bold header-title'>{t("whitepapers.download-whitepaper-for-free")}</p>
                <p className='pt-30 text-white'>Stay ahead of the curve with the latest insights on document security. Download our <span className='font-weight-semi-bold'>exclusive Whitepaper</span> - Document Security 2023 now!</p>
              </>
              :
              <>
                <p className='font-64 font-weight-semi-bold header-sub-title pr-lg-50'>Nhận thông tin chi tiết mới nhất về </p>
                <p className='font-64 font-weight-semi-bold header-sub-title'>Bảo mật tài liệu |</p>
                <p className='font-60 font-weight-semi-bold header-title'>{t("whitepapers.download-whitepaper-for-free")}</p>
                <p className='pt-30 text-white'>Luôn dẫn đầu với những hiểu biết mới nhất về bảo mật tài liệu. Tải xuống của chúng tôi <span className='font-weight-semi-bold'>Whitepaper độc quyền</span> - Bảo mật tài liệu 2023 ngay bây giờ!</p>
              </>
            }
            <div className='pt-30'>
              <PrimaryButton onClick={handleScroll}>{t('button.download-whitepaper-for-free')}</PrimaryButton>
            </div>
          </div>
          <div className='col-sm-12 col-xl-5 pt-50 pt-xl-0 px-xl-0'>
            <div className='flex justify-center' >
              <img src={document_security} alt="hr-document-security" className='img-responsive img-header' />
              <div className='document-security-behind-line'></div>
            </div>
          </div>
        </div>
      </div>
      <div className='container pt-70'>
        <div className='look-inside col-sm-12'>
          <div className='col-xl-5'>
            <div className='flex justify-center'>
              <img src={document_security} alt="qr_code_1" className='img-responsive' />
            </div>
          </div>
          <div className='col-xl-7 pt-60'>
            <p className='font-32 font-weight-semi-bold'>{t("whitepapers.looking-inside-the-whitepaper")}</p>
            <p className='pt-20'>
              {t('whitepapers.document-security.content')}
            </p>
            <div className='pt-20'>
              <PrimaryButton2th onClick={handleScroll}>{t('button.download-whitepaper-for-free')}</PrimaryButton2th>
            </div>
          </div>
        </div>
      </div>

      <WhitepaperDownloadForm />

      <OtherWhitepapers items={items} />

      <div className='container'>
        <IndustriesImageContainer />
      </div>
      <Footer />
    </div>
  )
}

export default DocumentSecurity